import { render } from "./DialogueTheme.vue?vue&type=template&id=ebd2bdec&scoped=true&ts=true"
import script from "./DialogueTheme.vue?vue&type=script&lang=ts"
export * from "./DialogueTheme.vue?vue&type=script&lang=ts"

import "./DialogueTheme.vue?vue&type=style&index=0&id=ebd2bdec&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd2bdec"]])

export default __exports__